<template>
	<popup title="Connect new domain" @close="closePopup">
		<template v-slot:content>
			<div class="automation-progress-panel popup_progress_panel">
				<div class="item-prog" :class="{deactivated: step.status === 'deactivated'}" v-for="step in steps"
				     :key="step.id">
					<div class="icon-status" :class="{'active': step.status === 'active' }">
						<inline-svg v-if="step.status === 'active' || step.status === 'deactivated'"
						            :src="require('@/assets/img/circle-arrow-right.svg')"/>
						<inline-svg v-if="step.status === 'completed'" :src="require('@/assets/img/circle-checked.svg')"/>

						<inline-svg v-if="step.status === 'error'" :src="require('@/assets/img/circle-error.svg')"/>
					</div>
					<div class="item-prog-text">
						<span>{{ step.status === 'error' ? 'Error' : step.name }}</span>
					</div>
				</div>
			</div>
			<div class="content">
				<div class="step-items">
					<div class="cnd_popup_step" v-if="stepState == 1">
						<input-field label="Domain" v-model="inputDomain" placeholder="mydomain.com"
						             @change="domainChanged"></input-field>
						<div class="input_under_text">Enter the domain you want to connect</div>
						<div class="alert_box red" v-if="verifyError">
              <span class="icon">
                  <inline-svg :src="require('@/assets/img/alert_icon_red.svg')"/>
              </span>
							<div v-html="verifyError">
							</div>
						</div>
					</div>
					<div class="cnd_popup_step" v-if="stepState == 2">
						<div class="alert_box red" v-if="verifyError">
              <span class="icon">
                  <inline-svg :src="require('@/assets/img/alert_icon_red.svg')"/>
              </span>
							<div v-html="verifyError">
							</div>
						</div>
						<p>In order to connect your domain “<b>{{ trimDomain(inputDomain) }}</b>” with <b>Funnelish</b> edit the
							following DNS settings:</p>
						<ul class="blue_dot_list">
							<li class="ip-container" >Your DNS CNAME record should point to this address <b>
								<input-field small flat value="funnels.funnelish.com" readonly is-copy select-all />
								</b>.</li>
							<li>Press the Verify button below to complete connecting your domain.</li>
						</ul>
						<div class="alert_box orange">
                            <span class="icon">
                                <inline-svg :src="require('@/assets/img/alert_icon_yellow.svg')"/>
                            </span>
							<ul style="list-style: disc outside;margin-left: 10px">
								<li>
									Depending on which DNS provider you use it might take <u>up to 24 hours</u> for your changes to propagate.
								</li>
								<li>
									It can take <u>up to 5 minutes</u> for Funnelish certification authority to generate an SSL certificate for your new domain.
								</li>
							</ul>
						</div>
					</div>
					<div class="cnd_popup_step step_3" v-if="stepState == 3">
						<p style="text-align: center;">
							Your domain connection has been verified.
						</p>
						<svg xmlns="http://www.w3.org/2000/svg" class="check-icon" version="1.1"
						     id="Capa_1" x="0px" y="0px" viewBox="0 0 456.556 456.556" style="height: 50px;margin: auto;"
						     xml:space="preserve">
                          <g>
                              <path class="path"
                                    d="M228.278,456.556C102.403,456.556,0,354.153,0,228.278S102.403,0,228.278,0c42.641,0,84.233,11.834,120.287,34.228   c6.301,3.91,8.232,12.19,4.322,18.492c-3.917,6.301-12.197,8.246-18.492,4.322c-31.794-19.751-68.49-30.185-106.117-30.185   c-111.065,0-201.422,90.36-201.422,201.422S117.213,429.7,228.278,429.7c111.062,0,201.422-90.36,201.422-201.422   c0-22.324-3.623-44.243-10.77-65.147c-2.399-7.015,1.35-14.652,8.365-17.051c7.029-2.385,14.652,1.35,17.051,8.365   c8.099,23.709,12.211,48.551,12.211,73.834C456.556,354.153,354.153,456.556,228.278,456.556z"
                                    style="fill: #a6a7ab;"></path>
	                          <path class="path"
	                                d="M228.278,305.727c-3.406,0-6.7-1.294-9.193-3.644L111.66,201.17c-5.406-5.077-5.672-13.575-0.594-18.981   c5.078-5.399,13.575-5.679,18.981-0.587l97.092,91.206L403.564,63.371c4.77-5.672,13.246-6.399,18.918-1.616   c5.672,4.777,6.399,13.246,1.616,18.918L238.545,300.951c-2.371,2.818-5.805,4.539-9.484,4.756   C228.803,305.72,228.537,305.727,228.278,305.727z"
	                                style="fill: #39e16f;"></path>
                          </g>
                      </svg>
					</div>
				</div>
			</div>
		</template>

		<template v-slot:actions>
			<template v-if="stepState === 1">
				<div class="btn brdr_btn" @click="closePopup">Cancel</div>
				<v-button :loading="connecting" label="Connect" @click="addDomain"
				          :disabled="!inputDomain.length"></v-button>
			</template>
			<template v-if="stepState === 2">
				<div class="btn brdr_btn" @click="backStep(1)">Back</div>
				<v-button :loading="verifying" label="Verify" @click="verifyDomain"></v-button>
			</template>
			<template  v-if="stepState === 3">
				<div class="btn brdr_btn" @click="closePopup">Done</div>
			</template>
		</template>
	</popup>
</template>

<script>

import API from "@/api"
import VButton from "@/components/base/v-button";
import InputField from "@/components/base/input-field";
import Popup from "@/components/base/popup";

export default {
	name: "ConnectNewDomainPopup",
	mixins: [API],
	components: {
		Popup,
		InputField,
		VButton

	},
	data() {
		return {
			connecting: false,
			verifying: false,
			stepState: 1,
			steps: [
				{
					id: 1,
					name: "Domain name",
					step: "Step1",
					status: "active"
				},
				{
					id: 2,
					name: "Domain connection",
					step: "Step2",
					status: "deactivated"
				},
				{
					id: 3,
					name: "Done",
					step: "Step3",
					status: "deactivated"
				}
			],
			inputDomain: '',
			updated: false,
			savedDomain: null,
			newDomain: {},
			verifyError: false,
			verifyMessage: ''
		}
	},
	methods: {
		trimDomain(domain) {
			var result = domain.trim()
			result = result.replace('http://', '');
			result = result.replace('https://', '');
			console.log(result);
			return result
		},
		closePopup() {
			this.$emit("close")
		},
		nextStep(numberStep) {
			this.stepState = numberStep;
			if (numberStep !== 1) {
				this.steps[numberStep - 2].status = "completed";
			} else {
				this.steps[numberStep - 1].status = "deactivated";
			}
			this.steps[numberStep - 1].status = 'active';

			if (numberStep === 3) {
				this.steps[numberStep - 1].status = "completed";
			}
		},
		backStep(numberStep) {
			this.stepState = numberStep;
			this.steps[numberStep - 1].status = 'active';
			this.steps[numberStep].status = 'deactivated';
		},
		domainChanged(val) {
			if (this.inputDomain.length && this.inputDomain !== this.savedDomain) {
				this.updated = true;
				this.savedDomain = this.trimDomain(this.inputDomain);
			}
		},
		async addDomain() {
			try {
				this.connecting = true;
				this.verifyError = false;

				if (this.updated) {
					this.newDomain = {
						// "user_id": parseInt(this.$store.state.userInfo.id),
						"name": this.trimDomain(this.inputDomain)
					}
					// Do not create domains manually only call validate.
					let validate = await this.api.wsteps.validateDomain(this.newDomain);
					if (validate.error) {
						this.$error(validate, validate.info.data);
						this.verifyError = validate.info.data;
						return
					}
				}
				this.nextStep(2);
			} catch (e) {
				console.error("ERROR", e);
				this.$notify({
					type: "error",
					group: "main",
					title: "Something went wrong... Please try again later",
				});
			} finally {
				this.connecting = false;
			}
		},
		async verifyDomain() {
			try {
				this.verifying = true;
				this.verifyMessage = null;
				this.verifyError = null;

				let verifyResult = await this.api.wsteps.verifyDomain(this.newDomain);

				if (verifyResult.error) {
					this.verifyError = verifyResult.info.data
				} else {
					this.newDomain = verifyResult;
					this.nextStep(3);
					this.verifyMessage = verifyResult;
					this.$emit("done", verifyResult);
				}
			} catch (e) {
				console.error("ERROR", e);
				this.$notify({
					type: "error",
					group: "main",
					title: "Something went wrong... Please try again later",
				});
			} finally {
				this.verifying = false;
			}
		}
	},
	computed: {}
}
</script>
<style lang="scss" scoped>
.ip-container {
	display: flex;
	align-items: center;
	.input-field {
		margin-left: 5px;
		width: 185px;
	}
}
</style>
